export default __webpack_public_path__ + "static/media/simon_inactive.a1c28422.svg";